module.exports = __webpack_public_path__ + "static/media/nsa-logo-new.183782a6.png";